import StyledContainer from "style/styledContainer";
import styled, { css } from "styled-components";
import { DefaultTheme } from "styled-components/dist/types";

import { ReactComponent as GridSvg } from 'assets/svgs/grid_icon.svg'
import { ReactComponent as LanguageSvg } from 'assets/svgs/language_icon.svg'
import { useState } from "react";
import { Tooltip } from "react-tooltip";
import SvgCom from "./SvgCom";

const SwitchBtnCom = () => {
    const [curIndex, setCurIndex] = useState('classic')

    return (
        <SwitchBtnWrap>
            <BtnItemLeftWrap $active={curIndex === 'classic'} onClick={() => setCurIndex('classic')}>
                <GridSvgWrap></GridSvgWrap>
                <BtnLabel>Classic view</BtnLabel>
            </BtnItemLeftWrap>
            {/* onClick={() => setCurIndex('language')} $active={curIndex === 'language'} */}
            <BtnItemRightWrap id="comingSoon">
                <LanguageSvgWrap></LanguageSvgWrap>
                <BtnLabel>Natural language</BtnLabel>
            </BtnItemRightWrap>
            <Tooltip place="bottom" anchorSelect="#comingSoon" 
                content="Coming Soon"
                style={{ backgroundColor: "rgb(255, 255, 255)", color: "#0A0A0A" }}
            ></Tooltip>
        </SwitchBtnWrap>
    );
}


interface CommonSwitchProps {
    curIndex: number
    options: any[]
    onClick: (curIndex: number) => void 
}

export const CommonSwitchBtnCom = ({curIndex, options, onClick}: CommonSwitchProps) => {
    return <SwitchBtnWrap>
        {
            options.map((item, index) => <BtnItemWrap key={index}  $active={curIndex === index} onClick={() => onClick(index)}>
                <SvgComWrap Svg={item.icon}></SvgComWrap>
                <BtnLabel>{item.label}</BtnLabel>
            </BtnItemWrap>)
        }
    </SwitchBtnWrap>
}

const SwitchBtnWrap = styled(StyledContainer)`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

const btnItemStyle = (theme: DefaultTheme, active: boolean, disabled?: boolean) => {
    return css`
        padding: 10px 12px;
        display: flex;
        align-items: center;
        background-color: ${active ? theme.basicWhite : theme.lightGrey};

        &:hover {
            ${
                disabled ? css``: css`
                    ${BtnLabel} {
                        color: ${theme.basicBlack};
                    }
                    ${LanguageSvgWrap}, ${GridSvgWrap}, ${SvgComWrap} {
                        rect, path {
                            fill: ${theme.basicBlack};
                        }
                    }
                `
            }
        }

        ${
            active ? css`
                ${BtnLabel} {
                    font-family: RoobertMedium;
                    color: ${theme.basicPurple} !important;
                }

                box-shadow: 0px 14px 64px -4px rgba(24, 39, 75, 0.12), 0px 8px 22px -6px rgba(24, 39, 75, 0.12);
            ` : css`
                ${BtnLabel} {
                    font-family: RoobertRegular;
                    color: ${theme.deepGrey};
                }
            `
        }

        ${
            active ? css`
                ${GridSvgWrap}, ${LanguageSvgWrap}, ${SvgComWrap} {
                    rect, path {
                        fill: ${theme.basicPurple} !important;
                    }
                }
            ` : css`
                ${GridSvgWrap}, ${LanguageSvgWrap}, ${SvgComWrap} {
                    rect, path {
                        fill: ${theme.deepGrey};
                    }
                }
            `
        }
    `
}

const btnItemSvgStyle = () => {
    return css`
        width: 16px;
        height: 16px;
        rect, path {
            transition: all linear 0.2s;
        }
    `
}

const BtnItemLeftWrap = styled(StyledContainer)<{$active: boolean}>`
    ${({theme, $active}) => btnItemStyle(theme, $active)}
    border-radius: 9px 0px 0px 9px;
`

const BtnItemRightWrap = styled(StyledContainer)<{$active: boolean}>`
    ${({theme, $active}) => btnItemStyle(theme, $active, true)}
    border-radius: 0px 9px 9px 0px;
`

const GridSvgWrap = styled(GridSvg)`
    ${btnItemSvgStyle()}
`

const LanguageSvgWrap = styled(LanguageSvg)`
    ${btnItemSvgStyle()}
`

const BtnLabel = styled(StyledContainer)`
    font-size: 12px;
    line-height: 14px;
    margin-left: 6px;
    font-weight: 400;
`


// 公用组件样式

const SvgComWrap = styled(SvgCom)``

const BtnItemWrap = styled(StyledContainer)<{$active: boolean}>`
    ${({theme, $active}) => btnItemStyle(theme, $active)}

    &:first-child {
        border-radius: 9px 0px 0px 9px;
    }
    &:last-child {
        border-radius: 0px 9px 9px 0px;
    }
`
export default SwitchBtnCom;